import { render, staticRenderFns } from "./tableSales.vue?vue&type=template&id=0c95e206&scoped=true"
import script from "./tableSales.vue?vue&type=script&lang=js"
export * from "./tableSales.vue?vue&type=script&lang=js"
import style0 from "./tableSales.vue?vue&type=style&index=0&id=0c95e206&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c95e206",
  null
  
)

export default component.exports